(() => {

const entrance = document.querySelector('.grand-entrance');
if (entrance && document.documentElement.classList.contains('grand-first-entry')) {
  try { sessionStorage.setItem('wgyb-entrance-seen', '1'); } catch (_) {}
  const finishEntrance = () => {
    document.documentElement.classList.remove('grand-first-entry');
    entrance.remove();
  };
  window.setTimeout(finishEntrance, 3900);
  window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', event => { if (event.matches) finishEntrance(); }, { once: true });
} else {
  entrance?.remove();
}


// Keep the custom Bag label in sync with Horizon cart mutations.
import('@shopify/events').then(({ StandardEvents }) => {
  let latestCartUpdate = 0;
  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    const update = ++latestCartUpdate;
    event.promise?.then(({ cart, detail }) => {
      if (update !== latestCartUpdate) return;
      // Let Horizon resolve pending selections and submit the cart exactly once.
      // Navigate only after its own add request has completed successfully.
      if (detail?.source === 'product-form-component' && detail.didError === false) {
        const cartLink = document.querySelector('.grand-bag');
        if (cartLink) window.location.assign(cartLink.href);
      }
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (!Number.isInteger(count) || count < 0) return;
      document.querySelectorAll('[data-grand-count]').forEach(label => {
        label.textContent = `(${count})`;
        const accessibleLabel = label.getAttribute('aria-label');
        if (accessibleLabel) label.setAttribute('aria-label', accessibleLabel.replace(/\d+/, String(count)));
      });
    }).catch(() => {});
  });
}).catch(error => console.warn('[grand-bag] Cart events unavailable:', error));

function initializeGrandMenu() {
  const dialog = document.getElementById('GrandMenu');
  const trigger = document.querySelector('.grand-menu-trigger');
  if (!dialog || !trigger || trigger.dataset.ready) return;
  trigger.dataset.ready = 'true';
  trigger.addEventListener('click', () => dialog.showModal());
  dialog.querySelector('[data-grand-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
}
initializeGrandMenu();
const grandHeader = document.querySelector('.grand-header--home');
if (grandHeader) {
  const updateGrandHeader = () => grandHeader.classList.toggle('grand-header--scrolled', (document.querySelector('.grand-hero')?.getBoundingClientRect().top ?? 0) < -80);
  window.addEventListener('scroll', updateGrandHeader, { passive: true, capture: true });
  updateGrandHeader();
}
document.addEventListener('shopify:section:load', initializeGrandMenu);


function initializeGrandMotion() {
  const root = document.querySelector('.grand');
  if (!root || root.dataset.motionReady) return;
  root.dataset.motionReady = 'true';
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  let frame = 0;
  const targets = root.querySelectorAll('.grand-intro > *, .grand-feature-copy > *, .grand-explore-heading > *, .grand-path, .grand-closing > *, .grand-wide-copy > *');
  const images = root.querySelectorAll('.grand-hero-image, .grand-wide > img');
  function updateParallax() {
    frame = 0;
    if (preference.matches) return;
    for (const image of images) {
      const rect = image.parentElement.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) continue;
      const offset = Math.max(-35, Math.min(35, -rect.top * 0.045));
      image.style.setProperty('--grand-pan', offset + 'px');
    }
  }
  function requestParallax() {
    if (!frame && !preference.matches) frame = window.requestAnimationFrame(updateParallax);
  }
  function configureMotion() {
    observer?.disconnect();
    if (preference.matches) {
      root.classList.remove('grand-motion');
      targets.forEach(element => element.classList.remove('grand-reveal', 'grand-revealed'));
      images.forEach(image => image.style.removeProperty('--grand-pan'));
      return;
    }
    if (!('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('grand-revealed');
          observer.unobserve(entry.target);
        }
      }
    }, { threshold: 0.12 });
    targets.forEach((element, index) => {
      element.classList.add('grand-reveal');
      element.style.setProperty('--grand-delay', ((index % 3) * 90) + 'ms');
      observer.observe(element);
    });
    root.classList.add('grand-motion');
    requestParallax();
  }
  configureMotion();
  preference.addEventListener('change', configureMotion);
  window.addEventListener('scroll', requestParallax, { passive: true, capture: true });
}
initializeGrandMotion();
document.addEventListener('shopify:section:load', initializeGrandMotion);

})();